//电站列表
export const SELECT_DEVICE='home/deviceinfolist/SELECT_DEVICE';
